import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import TextButton from '../../../../../Buttons/TextButton';
import { MODAL_FOOTER_BUTTON_SIZE, MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH } from '../../../Modal';
import s from './CancelButton.scss';
const CancelButton = (_param)=>{
    var { children } = _param, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(TextButton, _object_spread({
        size: MODAL_FOOTER_BUTTON_SIZE,
        style: {
            minWidth: MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH
        },
        variant: "main",
        className: s['root']
    }, rest), children);
};
CancelButton.displayName = 'CancelButton';
export default CancelButton;
